import { Grid } from "@material-ui/core";
import { Button, StandardDialog, Toolbar } from "@roc/ui";
import { observer } from "mobx-react";
import { useEffect, useRef, useState } from "react";
import { LoanVendorsModal } from "./loanVendorsModal";
import { LoanVendorSearchBar } from "./loanVendorSearchBar";
import { useLoanVendorStore } from "../../hooks/userLoanVendorStore";

export const LoanVendorToolbar = observer(({}) => {
  const anchorRef = useRef(null);
  const [openLoanVendorModal, setOpenLoanVendorModal] = useState(false);
  const { loanVendorStore } = useLoanVendorStore();

  const handleOpen = () => {
    setOpenLoanVendorModal(true);
  };

  useEffect(() => {}, [loanVendorStore.loanVendor]);

  return (
    <Grid container>
      <Grid item xs={12}>
        <Toolbar
          left={
            <>
              <LoanVendorSearchBar />
            </>
          }
        >
          <Actions anchorRef={anchorRef} handleOpen={handleOpen} disabled={!loanVendorStore.loanVendor}/>
        </Toolbar>
      </Grid>
      <LoanVendorsModal
        open={openLoanVendorModal}
        onClose={() => setOpenLoanVendorModal(false)}
      />
    </Grid>
  );
});

const Actions = ({ anchorRef, handleOpen, disabled }) => {

  return (
    <div ref={anchorRef} style={{ display: "inline-block" }}>
      <Button
        id="basic-button"
        aria-controls={open ? "basic-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        onClick={() => {
          handleOpen();
        }}
        testId="open_menu"
        variant="contained"
        size="small"
        color="primary"
        disabled={disabled}
      >
        Add Loan
      </Button>
    </div>
  );
};
